import styled from 'styled-components'
import media from '../../utils/responsiveBreakpoints'

export const PreviewContainerWhiteBackground = styled.div`
  width: 100%;
  padding-top: 3rem;
  & > div {
    width: 100%;
  }
`

export const PreviewContainerGrayBackground = styled.div`
  width: 100%;
  background-image: linear-gradient(rgb(247, 247, 248), rgb(255, 255, 255));
  padding-top: 3rem;
  & > div {
    width: 100%;
  }
`

export const HeadingContainer = styled.div`
  margin-bottom: 1.5rem;
`

export const BottomNavigationContainer = styled.div`
  margin: 3.75rem 0rem 0.75rem 0rem;
  display: flex;
  justify-content: center;
  ${{
    ...media.from('md').css({
      margin: '3rem 0rem 2.5rem 0rem',
    }),
  }}
`

export const LoadingContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
})

// helper
export const StoryContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  & > div {
    margin-top: 4.5rem;
  }
  & > div:first-child {
    margin-top: 0;
  }
  ${{
    ...media.from('sm').css({
      '& > div': {
        marginTop: '3rem',
      },
      '& > div:nth-child(-n+2)': {
        // the first row
        marginTop: '0rem',
      },
    }),
  }}
  ${{
    ...media.from('md').css({
      '& > div': {
        marginTop: '3rem',
      },
      '& > div:nth-child(-n+2)': {
        // the first row
        marginTop: '0rem',
      },
    }),
  }}
  ${{
    ...media.from('lg').css({
      '& > div:nth-child(-n+3)': {
        // the first row
        marginTop: '0rem',
      },
    }),
  }}
`

export const BlogContainer = styled.div`
  paddingtop: 2rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(380px, 1fr));
  width: 100%;
  ${{
    ...media.from('md').css({
      gridTemplateColumns: 'repeat(2, minmax(auto, 1fr))',
    }),
  }}
  ${{
    ...media.from('xl').css({
      gridTemplateColumns: 'repeat(3, minmax(auto, 1fr))',
    }),
  }}
`
